import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Subscription} from 'rxjs';
import {CONSTANTS} from 'src/app/constants';
import {Alert, AlertsService} from 'src/app/providers/services/alerts.service';
import {AuthService} from 'src/app/providers/services/auth.service';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MenuComponent implements OnInit, OnDestroy {

  amountOfAlerts: number;
  private alertsSubscription: Subscription;
  CONSTANTS = CONSTANTS;

  constructor(
    private authService: AuthService,
    private alertsService: AlertsService,
  ) { }

  ngOnInit(): void {
    this.alertsSubscription = this.alertsService.alerts$.subscribe((alerts: Alert[]) => {
      this.amountOfAlerts = alerts.length;
    });
  }

  ngOnDestroy(): void {
    if (this.alertsSubscription) { this.alertsSubscription.unsubscribe(); }
  }
  
  async logout() {
    await this.authService.logout();
  }
}
